import {
  LOAD_CASES,
  SET_CASES,
  LOAD_CASE_STATS,
  SET_CASE_STATS,
  SET_COMPLETED_CASES,
  SET_ACTIVE_TAB,
  CREATE_CASE,
  SET_ACTIVE_CASE,
  DISCARD_ACTIVE_CASE,
  UPDATE_CASE,
  RESET_CASES,
  SET_SELECTED_FLOW,
  LOAD_CASE_NOTES,
  SET_CASE_NOTES,
  ADD_CASE_NOTE,
  UPDATE_CASE_NOTE,
  LOAD_COMPLETED_CASES, LOAD_ARCHIVED_CASES, SET_ARCHIVED_CASES,
} from '../actions/actionTypes';

const initialState = {
  list: [],
  stats: {
    totalCases: 0,
    futureCases: 0,
    postponedCases: 0,
  },
  statsLoading: false,
  activeCase: null,
  activeTab: 0,
  selectedFlow: null,
  loading: false,
  isLoaded: false,
  completedCases: [],
  completedLoading: false,
  completedLoaded: false,
  archivedCases: [],
  archivedLoading: false,
  archivedLoaded: false,
};

const normalizeCase = (caseItem) => {
  if (!caseItem) {
    return caseItem;
  }

  return {
    ...caseItem,
    files: Array.isArray(caseItem.files) ? caseItem.files : [],
    isHydrated: typeof caseItem.isHydrated === 'boolean' ? caseItem.isHydrated : !!caseItem.patientInfo,
  };
};

const getNotesStateForActiveCase = (state, caseItem) => {
  const isSameCase = state.activeCase?.id && state.activeCase.id === caseItem?.id;

  if (isSameCase) {
    return {
      caseNotes: state.activeCase?.caseNotes || [],
      caseNotesLoading: !!state.activeCase?.caseNotesLoading,
      caseNotesLoaded: !!state.activeCase?.caseNotesLoaded,
    };
  }

  if (Array.isArray(caseItem?.caseNotes)) {
    return {
      caseNotes: caseItem.caseNotes,
      caseNotesLoading: false,
      caseNotesLoaded: true,
    };
  }

  return {
    caseNotes: [],
    caseNotesLoading: !!caseItem?.id,
    caseNotesLoaded: false,
  };
};

const casesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CASES:
      return { ...state, loading: true };
    case SET_CASES:
      return { ...state, loading: false, list: action.cases, isLoaded: true };
    case LOAD_CASE_STATS:
      return { ...state, statsLoading: true };
    case SET_CASE_STATS:
      return { ...state, statsLoading: false, stats: action.stats };
    case LOAD_COMPLETED_CASES:
      return { ...state, completedLoading: true };
    case SET_COMPLETED_CASES:
      return { ...state, completedLoading: false, completedCases: [...state.completedCases, ...action.cases], completedLoaded: true };
    case LOAD_ARCHIVED_CASES:
      return { ...state, archivedLoading: true };
    case SET_ARCHIVED_CASES:
      return { ...state, archivedLoading: false, archivedCases: [...state.archivedCases, ...action.cases], archivedLoaded: true };
    case SET_ACTIVE_TAB:
      return { ...state, activeTab: action.tab };
    case SET_SELECTED_FLOW:
      return { ...state, selectedFlow: action.flow };
    case CREATE_CASE:
      return {
        ...state,
        // list: [...state.list, action.case].sort((a, b) => (a.date > b.date ? 1 : -1)),
        activeCase: normalizeCase(action.case),
        loading: false,
      };
    case UPDATE_CASE:
      const updatedCase = state.list.find((item) => item.id === action.case.id);
      const newCase = normalizeCase({
        ...updatedCase,
        ...action.case,
        ...getNotesStateForActiveCase(state, { ...updatedCase, ...action.case }),
      });

      return {
        ...state,
        list: state.list.map((item) => (item.id === action.case.id ? newCase : item)),
        activeCase: newCase,
        loading: false,
      };
    case SET_ACTIVE_CASE:
      return {
        ...state,
        activeCase: normalizeCase({
          ...action.case,
          ...getNotesStateForActiveCase(state, action.case),
        }),
        loading: false,
      };
    case LOAD_CASE_NOTES:
      if (state.activeCase?.id !== action.caseId) {
        return state;
      }

      return {
        ...state,
        activeCase: normalizeCase({
          ...state.activeCase,
          caseNotes: [],
          caseNotesLoading: true,
          caseNotesLoaded: false,
        }),
      };
    case SET_CASE_NOTES:
      if (state.activeCase?.id !== action.caseId) {
        return state;
      }

      return {
        ...state,
        activeCase: normalizeCase({
          ...state?.activeCase,
          caseNotes: action.notes || [],
          caseNotesLoading: false,
          caseNotesLoaded: true,
        }),
      };
    case ADD_CASE_NOTE:
      if (action.caseId && state.activeCase?.id !== action.caseId) {
        return state;
      }

      return {
        ...state,
        activeCase: normalizeCase({
          ...state?.activeCase,
          caseNotes: [action.note, ...(state?.activeCase?.caseNotes || [])],
          caseNotesLoading: false,
          caseNotesLoaded: true,
        }),
      };
    case UPDATE_CASE_NOTE:
      return {
        ...state,
        activeCase: normalizeCase({
          ...state?.activeCase,
          caseNotes: (state?.activeCase?.caseNotes || []).map((note) => (
            note.id === action.note.id ? { ...note, ...action.note } : note
          )),
        }),
      };
    case DISCARD_ACTIVE_CASE:
      return { ...state, activeCase: null, activeTab: 0, selectedFlow: null, loading: false };
    case RESET_CASES:
      return { ...state, isLoaded: false };
    default:
      return state;
  }
};

export default casesReducer;
